import PrivateRoute from "@/router/PrivateRoot";
import AdminDashboardPage from "@/pages/admin/dashboard/adminDashboardPage";
import {Outlet} from "react-router-dom";
import AdminPollListPage from "@/pages/admin/poll/adminPollListPage";
import AdminSettingDashboardPage from "@/pages/admin/setting/adminSettingDashboardPage";
import AdminSurveyListPage from "@/pages/admin/survey/adminSurveyListPage";
import AdminSurveyCreatePage from "@/pages/admin/survey/create/adminSurveyCreatePage";
import AdminSurveyResultListPage from "@/pages/admin/survey/result/adminSurveyResultListPage";
import AdminSurveyEditPage from "@/pages/admin/survey/edit/adminSurveyEditPage";
import AdminDashboardMemberPage from "@/pages/admin/member/dashboard/AdminDashboardMemberPage";
import AdminMemberListPage from "@/pages/admin/member/list/memberListPage";
import AdminEditMember from "@/pages/admin/member/[id]/AdminEditMember";
import AdminDiscountCreatePage from "@/pages/admin/discount/create/AdminDiscountCreatePage";
import AdminDiscountDashboardPage from "@/pages/admin/discount/dashborard/AdminDiscountDashboardPage";
import AdminDiscountListPage from "@/pages/admin/discount/list/AdminDiscountListPage";
import AdminDiscountEditPage from "@/pages/admin/discount/edit/[id]/AdminDiscountEditPage";
import ErrorPage from "@/components/error/ErrorPage";
import {RolesListPage} from "@/pages/admin/roles/RolesListPage";
import {AdminRolesEditPage} from "@/pages/admin/roles/[id]/AdminRolesEditPage";
import AdminImportList from "@/pages/admin/setting/import/AdminImportList";
import AdminImportCreate from "@/pages/admin/setting/import/AminImportCreate";
import AdminClassroomListPage from "@/pages/admin/classroom/list/AdminClassroomListPage";
import AdminClassroomCreatePage from "@/pages/admin/classroom/create/AdminClassroomCreatePage";
import AdminClassroomEditPage from "@/pages/admin/classroom/edit/[id]/AdminClassroomEditPage";
import AdminClassroomMapPage from "@/pages/admin/classroom/map/AdminClassroomMapPage";
import AdminAcademySettingPage from "@/pages/admin/setting/Academy/AdminAcademySettingPage";
import SmsHistoryPage from "@/pages/admin/setting/Sms/SmsHistoryPage";
import AdminSystemConfig from "@/pages/admin/setting/System/AdminSystemConfig";
import AdminRefundConfig from "@/pages/admin/setting/Refund/AdminRefundConfig";

import AdminEditRefundPage from "@/pages/admin/refund/[id]/AdminEditRefundPage";
import AdminTopicListPage from "@/pages/admin/topic/AdminTopicListPage";
import AdminEditTopicPage from "@/pages/admin/topic/[id]/AdminEditTopicPage";
import AdminProductList from "@/pages/admin/products/list/AdminProductList";
import AdminProductCreate from "@/pages/admin/products/create/AdminProductCreate";
import AdminProductEdit from "@/pages/admin/products/[id]/AdminProductEdit";
import AdminUsersToDelivery from "@/pages/admin/products/members/AdminUsersToDelivery";
import AdminProductDashboard from "@/pages/admin/products/dashboard/AdminProductDashboard";
import AdminProductDeliveryCreate from "@/pages/admin/products/delivery/create-step/AdminProductDeliveryCreate";
import AdminProductDeliveryStepList from "@/pages/admin/products/delivery/AdminProductDeliveryStepList";
import AdminProductDeliveryList from "@/pages/admin/products/delivery/list/AdminProductDeliveryList";
import AdminProductReceiptSearchAndPrint from "@/pages/admin/products/delivery/print/AdminProductReceiptPrint";
import AdminProductReceiptSearchAndDeliver from "@/pages/admin/products/delivery/deliver/AdminProductReceiptPrint";
import AdminProductDeliveryEdit from "@/pages/admin/products/delivery/[id]/AdminProductDeliveryEdit";
import AdminExportPage from "@/pages/admin/export/AdminExportPage";
import ProductDeliveryCategoryStatistic
    from "@/pages/admin/products/delivery/category-statistic/ProductDeliveryCategoryStatistic";
import AdminProductSearchAndDeliverToLesson
    from "@/pages/admin/products/delivery/deliver-to-lesson/AdminProductReceiptPrint";
import AdminProductReceiptSearchAndPrintToLesson
    from "@/pages/admin/products/delivery/print-lesson/AdminProductReceiptSearchAndPrintToLesson";
import AdminRefundGroupListPage from "@/pages/admin/refund/group/AdminRefundGroupListPage";
import AdminRefoundGroupEditPage from "@/pages/admin/refund/group/[id]/AdminRefoundGroupEditPage";
import AdminRefoundGroupCreate from "@/pages/admin/refund/group/create/AdminRefoundGroupCreate";
import AdminRefundDashboard from "@/pages/admin/refund/AdminRefundDashboard";
import AdminRefundListPage from "@/pages/admin/refund/items/AdminRefundListPage";
import AdminGroupListPage from "@/pages/admin/group/list/AdminGroupListPage";
import AdminGroupCreatePage from "@/pages/admin/group/create/AdminGroupCreatePage";
import AdminGroupEditPage from "@/pages/admin/group/edit/[id]/AdminGroupEditPage";
import AdminGradeListPage from "@/pages/admin/grade/list/AdminGradeListPage";
import AdminGradeEditPage from "@/pages/admin/grade/edit/[id]/AdminGradeEditPage";
import AdminGradeCreatePage from "@/pages/admin/grade/Create/AdminGradeCreatePage";

export const AdminRoute = [
    {
        path: '/admin',
        element: <PrivateRoute module={'admin'}/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                element: <AdminDashboardPage/>,
            },
            {
                path: `members`,
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminDashboardMemberPage/>,
                    },
                    {
                        path: 'list',
                        element: <AdminMemberListPage/>,
                    },
                    {
                        path: ':id',
                        element: <AdminEditMember/>,
                    }
                ]
            },
            {
              path: 'groups',
              element: <Outlet />,
              children: [
                  {
                      index: true,
                      element: <AdminGroupListPage/>,
                  },
                  {
                      path: 'create',
                      element: <AdminGroupCreatePage/>,
                  },
                  {
                      path: 'edit/:id',
                      element: <AdminGroupEditPage/>,
                  }
              ]
            },
            {
                path: 'grades',
                element: <Outlet />,
                children: [
                    {
                        index: true,
                        element: <AdminGradeListPage/>,
                    },
                    {
                        path: 'create',
                        element: <AdminGradeCreatePage/>,
                    },
                    {
                        path: 'edit/:id',
                        element: <AdminGradeEditPage/>,
                    }
                ]
            },
            {
                path: `poll`,
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminPollListPage/>,
                    }
                ]
            },
            {
                path: 'setting',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminSettingDashboardPage/>,
                    },
                    {
                        path: 'academy',
                        element: <AdminAcademySettingPage/>,
                    },
                    {
                        path: 'sms',
                        element: <SmsHistoryPage/>,
                    },
                    {
                        path: 'system',
                        element: <AdminSystemConfig/>,
                    },
                    {
                        path: 'refund',
                        element: <AdminRefundConfig/>,
                    },
                    {
                        path: 'imports',
                        element: <AdminImportList/>,
                    },
                    {
                        path: 'imports/create',
                        element: <AdminImportCreate/>,
                    },
                    {
                        path: 'exports',
                        element: <AdminExportPage/>,
                    },
                ]
            },

            {
                path: 'roles',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <RolesListPage/>,
                    },
                    {
                        path: `:id`,
                        element: <AdminRolesEditPage/>,
                    }
                ]
            },
            {
                path: 'discount',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminDiscountDashboardPage/>,
                    },
                    {
                        path: `create`,
                        element: <AdminDiscountCreatePage/>,
                    },

                    {
                        path: `list`,
                        element: <AdminDiscountListPage/>,
                    },
                    {
                        path: `edit/:id`,
                        element: <AdminDiscountEditPage/>,
                    }

                ]
            },
            {
                path: 'refund',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminRefundDashboard/>,
                    },
                    {
                        path: 'items',
                        element: <AdminRefundListPage/>,
                    },
                    {
                        path: 'edit/:id',
                        element: <AdminEditRefundPage/>,
                    },
                    {
                        path: 'groups',
                        element: <Outlet/>,
                        children: [
                            {
                                index: true,
                                element: <AdminRefundGroupListPage/>,
                            },
                            {
                                path: `edit/:id`,
                                element: <AdminRefoundGroupEditPage/>,
                            },
                            {
                                path: `create`,
                                element: <AdminRefoundGroupCreate/>,
                            }
                        ]
                    }


                ]
            },
            {
                path: 'products',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminProductDashboard/>,
                    },
                    {
                        path: 'list',
                        element: <AdminProductList/>,
                    },
                    {
                        path: 'create',
                        element: <AdminProductCreate/>,
                    },
                    {
                        path: 'delivery',
                        element: <AdminProductDeliveryStepList/>,
                    },
                    {
                        path: 'delivery/create',
                        element: <AdminProductDeliveryCreate/>,
                    },
                    {
                        path: 'delivery/receipt',
                        element: <AdminProductDeliveryList/>,
                    },
                    {
                        path: 'delivery/:id',
                        element: <AdminProductDeliveryEdit/>,
                    },
                    {
                        path: 'delivery/deliver',
                        element: <AdminProductReceiptSearchAndDeliver/>,
                    },
                    {
                        path: 'delivery/deliver/lesson',
                        element: <AdminProductSearchAndDeliverToLesson/>,
                    },
                    {
                        path: 'delivery/deliver/receipt-lesson',
                        element: <AdminProductReceiptSearchAndPrintToLesson/>,
                    },

                    {
                        path: 'delivery/search',
                        element: <AdminProductReceiptSearchAndPrint/>,
                    },
                    {
                        path: 'delivery/category/:category?',
                        element: <ProductDeliveryCategoryStatistic/>,
                    },
                    {
                        path: 'members',
                        element: <AdminUsersToDelivery/>,
                    },
                    {
                        path: ':id',
                        element: <AdminProductEdit/>,
                    }

                ]
            },
            {
                path: 'topics',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminTopicListPage/>,
                    },
                    {
                        path: ':id',
                        element: <AdminEditTopicPage/>,
                    }

                ]
            },
            {
                path: 'classroom',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminClassroomListPage/>,
                    },
                    {
                        path: `map`,
                        element: <AdminClassroomMapPage/>,
                    },
                    {
                        path: `create`,
                        element: <AdminClassroomCreatePage/>,
                    },

                    {
                        path: `list`,
                        element: <AdminClassroomListPage/>,
                    },
                    {
                        path: `edit/:id`,
                        element: <AdminClassroomEditPage/>,
                    }

                ]
            },
            {
                path: `survey`,
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <AdminSurveyListPage/>,
                    },
                    {
                        path: 'create',
                        element: <AdminSurveyCreatePage/>,
                    },
                    {
                        path: 'result',
                        element: <AdminSurveyResultListPage/>,
                    },
                    {
                        path: 'edit/:id',
                        element: <AdminSurveyEditPage/>,
                    }
                ]
            }
        ],
    },
]
